import React from 'react';
import Image from '../../../components/AppImage';

const TeamSelector = ({ teams, selectedTeam, onSelect }) => {
  return (
    <div>
      <label className="block text-sm font-medium text-foreground mb-2">
        Select Team
      </label>
      <select
        value={selectedTeam?.id || ''}
        onChange={(e) => {
          const team = teams?.find(t => t?.id === e?.target?.value);
          onSelect(team);
        }}
        className="w-full px-4 py-3 border border-border rounded-lg bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary">
        <option value="">Choose a team...</option>
        {teams?.map((team) => (
          <option key={team?.id} value={team?.id}>
            {team?.name} ({team?.country})
          </option>
        ))}
      </select>
      
      {selectedTeam && (
        <div className="mt-2 p-3 bg-muted/30 rounded-lg">
          <div className="flex items-center gap-3">
            <Image
              src={selectedTeam?.logo || 'https://img.rocket.new/generatedImages/rocket_gen_img_16b616325-1766600649637.png'}
              alt={selectedTeam?.logoAlt || `${selectedTeam?.name} logo`}
              className="w-8 h-8 rounded-full object-cover"
            />
            <div>
              <p className="text-sm font-medium text-foreground">{selectedTeam?.name}</p>
              <p className="text-xs text-muted-foreground">{selectedTeam?.country}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TeamSelector;